import { DataBean } from "../DataBean";

export class CheckBanking extends DataBean {


    public async checkBankingConciliationData(idBankingConciliationData:any,applyToBankingStatement:any,idBankingStatementMovement:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliationData_checkBankingConciliationData_Number_Boolean_Number", [idBankingConciliationData,applyToBankingStatement,idBankingStatementMovement]);
    }

}